import React, { createContext, useContext, useLayoutEffect, useState } from "react";

const ThemeContext = createContext();
const THEME_STORAGE_KEY = "uztravel:theme:v2";

function readUrlTheme() {
  try {
    const theme = new URLSearchParams(window.location.search).get("theme");
    return theme === "light" || theme === "dark" ? theme : null;
  } catch {
    return null;
  }
}

function getInitialTheme() {
  try {
    const fromUrl = readUrlTheme();
    if (fromUrl) {
      window.localStorage.setItem(THEME_STORAGE_KEY, fromUrl);
      return fromUrl;
    }
    return window.localStorage.getItem(THEME_STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getInitialTheme);

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    root.dataset.theme = theme;
    root.style.colorScheme = theme;
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch {
      // Keep the selected theme active for this session when storage is unavailable.
    }
  }, [theme]);

  useLayoutEffect(() => {
    const syncTheme = (event) => {
      if (event.key !== THEME_STORAGE_KEY) return;
      if (event.newValue === "light" || event.newValue === "dark") setTheme(event.newValue);
    };
    window.addEventListener("storage", syncTheme);
    return () => window.removeEventListener("storage", syncTheme);
  }, []);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
